import { useAutoneTranslation } from '@autone/translations';
import * as React from 'react';

import { Button, type ButtonProps, DropdownMenuTrigger } from '../../../atoms';

export type AutoneFilterDropdownMenuTriggerProps = Omit<
  ButtonProps,
  'aria-label' | 'id' | 'children'
> &
  Partial<Pick<ButtonProps, 'aria-label' | 'id'>>;

export const AutoneFilterDropdownMenuTrigger = React.forwardRef<
  HTMLButtonElement,
  AutoneFilterDropdownMenuTriggerProps
>(
  (
    {
      className,
      variant = 'outline',
      'aria-label': ariaLabel = 'Open filters',
      id = 'autone-filter-dropdown-menu-trigger',
      ...props
    },
    ref,
  ) => {
    const { common } = useAutoneTranslation();

    return (
      <DropdownMenuTrigger asChild>
        <Button
          ref={ref}
          className={className}
          variant={variant}
          aria-label={ariaLabel}
          id={id}
          {...props}
        >
          {common('filters.header')}
        </Button>
      </DropdownMenuTrigger>
    );
  },
);
AutoneFilterDropdownMenuTrigger.displayName =
  'AutoneFilterDropdownMenu.Trigger';
